export const defaultStyles = {
  "logo": {
    "type": "JPEG",
    "width": 76,
    "height": 40,
    "marginTop": 15,
    "marginLeft": 25,
    "float": "left"
  },
  "firma": {
    "type": "PNG",
    "height": 80,
    "marginTop": 10,
    "marginBottom": 0,
    "marginLeft": 30
  },
  "piedefirma": {
    "fontSize": 10,
    "marginTop": 0,
    "marginBottom": 10,
    "marginLeft": 30,
    "borderWidth": 1,
    "borderColor": [155,155,155]
  },
  "encabezado": {
    "fontSize": 12,
    "marginTop": 10,
    "marginBottom": 4,
    "autoSize": false,
    "headersVisible": false,
    "borderWidth": 0,
    "borderColor": [
      255,
      255,
      255
    ]
  },
  "pie": {
    "fontSize": 10,
    "footerHeight": 10,
    "marginBottom": 4,
    "autoSize": false,
    "headersVisible": false,
    "borderWidth": 0,
    "borderColor": [
      255,
      255,
      255
    ]
  },
  "titulo1": {
    "fontSize": 14,
    "marginTop": 0,
    "marginBottom": 0,
    "borderWidth": 0,
    "borderColor": [
      255,
      255,
      255
    ]
  },
  "titulo2": {
    "fontSize": 12,
    "marginTop": 6,
    "marginBottom": 2,
    "marginLeft": 30,
    "textAlign": "left"
  },
  "parag": {
    "fontSize": 10,
    "marginTop": 6,
    "marginBottom": 2,
    "marginLeft": 30,
    "textAlign": "left"
  },
  "tabla1": {
    "fontSize": 10,
    "marginLeft": 30,
    "marginTop": 6,
    "marginBottom": 12,
    "autoSize": false,
    "headersVisible": false,
    "borderWidth": 0,
    "borderColor": [
      255,
      255,
      255
    ]
  },
  "tabla2": {
    "fontSize": 10,
    "marginLeft": 30,
    "marginTop": 6,
    "marginBottom": 12,
    "autoSize": false,
    "headersVisible": true,
    "borderWidth": 1,
    "borderColor": [
      255,
      255,
      255
    ]
  },
  "default": {
    "borderColor": [
      255,
      255,
      255
    ],
    "pageMarginTop": 20,
    "headersVisible": false,
    "float": "none",
    "footerHeight": 10,
    "marginBottom": 10,
    "autoSize": false,
    "fontFamily": "helvetica",
    "marginLeft": 20,
    "fontSize": 6,
    "borderWidth": 1,
    "pageMarginBottom": 20,
    "marginRight": 10,
    "grid": false,
    "marginTop": 10,
    "textAlign": "left"
  },
  "page": {
    "size": "210mm x 297mm == 595.28pt x 841.89pt",
    "width": 595.28,
    "height": 841.89,
    "format": "A4"
  }
}